export enum EnumPartnerPortfolioCNPJ {
  "UM" = "1",
  "2-9" = "2 até 9",
  "10-20" = "10 até 20",
  "21-50" = "21 até 50",
  "50-100" = "50 até 100",
  "100+" = "100+",
}
